import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import TextInput from '../../../common/inputs/text-input/TextInput';
import Button from '../../../common/button/Button';

import { ReactComponent as CircleClosed } from '../../../../resources/icons/circle_closed.svg';
import { ReactComponent as CircleOpen } from '../../../../resources/icons/circle_open.svg';
import { ReactComponent as GooglePlay } from '../../../../resources/icons/google_play_greyed_out.svg';
import { ReactComponent as AppStore } from '../../../../resources/icons/app_store_greyed_out.svg';
import { ReactComponent as AppGallery } from '../../../../resources/icons/appgallery_greyed_out.svg';
import { ReactComponent as EyeOpen } from '../../../../resources/icons/eye-open.svg';
import { ReactComponent as EyeClosed } from '../../../../resources/icons/eye-closed.svg';

import './keycloak-registration.scss';

const KeycloakRegistration = ({ register }) => {
  const [password, setPassword] = useState('');
  const [username, setUsername] = useState('');
  const [retypePassword, setRetypePassword] = useState('');
  const [noMatch, setNoMatch] = useState(false);
  const [passwordType, setPasswordType] = useState('password');
  const [retypePasswordType, setRetypePasswordType] = useState('password');

  const navigate = useNavigate();

  useEffect(() => {
    setNoMatch(password !== retypePassword ? true : false);
  }, [password, retypePassword]);

  const handleSignUpClick = () => {
    const keycloakRegistration = {
      username,
      password,
    };
    register(keycloakRegistration);
  };

  const changeViewPassword = (inputType) => {
    if (inputType === 'retype') {
      if (retypePasswordType === 'password') {
        setRetypePasswordType('input');
      } else {
        setRetypePasswordType('password');
      }
    } else {
      if (passwordType === 'password') {
        setPasswordType('input');
      } else {
        setPasswordType('password');
      }
    }
  };

  const checkForSpecialCharacter = () => {
    const specialCharRegex = /[!@#$%^&*()_+{}[\]:;<>,.?~\\/-123456789]/;

    return specialCharRegex.test(password);
  };

  const checkPasswordLength = () => password.length >= 8;

  const getNoMatchError = () => noMatch;

  return (
    <section className="keycloak-registration">
      <p className="keycloak-registration__heading">Please enter your user details:</p>

      <div className="keycloak-registration__form" data-testid="login-form">
        <TextInput
          name="username"
          placeholder="Username"
          value={username}
          onChange={({ target }) => setUsername(target.value)}
          type="username"
          auth
        />

        <TextInput
          name="password"
          placeholder="Password"
          value={password}
          onChange={({ target }) => setPassword(target.value)}
          type={passwordType}
          auth
          icon={
            passwordType === 'password' ? (
              <div className="keycloak-registration__eye-open">
                <EyeOpen onClick={() => changeViewPassword()} />
              </div>
            ) : (
              <div className="keycloak-registration__eye-closed">
                <EyeClosed onClick={() => changeViewPassword()} />
              </div>
            )
          }
        />

        <div className="keycloak-registration__requirements">
          <div className="keycloak-registration__requirement">
            {checkPasswordLength() ? <CircleClosed /> : <CircleOpen />}
            <p>At least 8 characters</p>
          </div>

          <div className="keycloak-registration__requirement">
            {checkForSpecialCharacter() ? <CircleClosed /> : <CircleOpen />}
            <p>Number or special character</p>
          </div>
        </div>

        <TextInput
          name="retype-password"
          placeholder="Retype Password"
          error={() => getNoMatchError()}
          value={retypePassword}
          onChange={({ target }) => setRetypePassword(target.value)}
          type={retypePasswordType}
          auth
          icon={
            retypePasswordType === 'password' ? (
              <div className="keycloak-registration__eye-open">
                <EyeOpen onClick={() => changeViewPassword('retype')} />
              </div>
            ) : (
              <div className="keycloak-registration__eye-closed">
                <EyeClosed onClick={() => changeViewPassword('retype')} />
              </div>
            )
          }
        />

        <div className="keycloak-registration__button-container">
          <Button onClick={() => navigate('/')}>Back</Button>
          <Button
            onClick={handleSignUpClick}
            disabled={!checkPasswordLength() || !checkForSpecialCharacter() || !password || getNoMatchError()}
          >
            Sign Up
          </Button>
        </div>
      </div>
      <div className="keycloak-registration__coming-soon">
        <p>Mobile app coming soon</p>
        <div className="keycloak-registration__store-logos">
          <GooglePlay />
          <AppStore />
          <AppGallery />
        </div>
      </div>
    </section>
  );
};

KeycloakRegistration.propTypes = {
  register: PropTypes.func.isRequired,
};

export default KeycloakRegistration;
